export default __webpack_public_path__ + "assets/fonts/0109a2ace896a506a0aac5f7a94a8efb.woff2";